module.exports = __webpack_public_path__ + "static/media/packages.19d27116.svg";